const getWatermarkHref = (gameName = "", textAlign = "left") => {
  const text = new URL("https://assets.imgix.net/~text");
  text.searchParams.set("txt", gameName.toUpperCase());
  text.searchParams.set("txt-align", textAlign);
  text.searchParams.set("txt-font", "AvenirNextCondensed-Bold");
  text.searchParams.set("txt-color", "white");
  text.searchParams.set("txt-size", "20");
  text.searchParams.set("txt-lead", `-0`);
  text.searchParams.set("txt-pad", "0");
  text.searchParams.set("dpr", "3");
  const watermark = new URL(
    "https://heathmont.imgix.net/images/1x1transparent.png",
  );
  watermark.searchParams.set("mark-align", "center,bottom");
  watermark.searchParams.set("mark-scale", "100");
  watermark.searchParams.set("mark-pad", "20");
  watermark.searchParams.set("w", "448");
  watermark.searchParams.set("h", "248");
  watermark.searchParams.set("mark", text.href);
  watermark.searchParams.set("dpr", "3");
  return encodeURIComponent(watermark.href);
};

export default getWatermarkHref;
